import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CreateDeliveryChecklistRoutingModule } from './create-delivery-checklist-routing.module';
import { SharedModule } from '../../shared/shared.module';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    CreateDeliveryChecklistRoutingModule,
    SharedModule,
  ]
})
export class CreateDeliveryChecklistModule { }
